/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { isString } from 'lodash-es';
import { useEffectOnce } from 'react-use';

export const useAdminSavedPageAndRow = (localStorageKey: string) => {
  const value = (() => {
    try {
      const storedValue = localStorage.getItem(localStorageKey);
      return isString(storedValue) ? JSON.parse(storedValue) : null;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return null;
    }
  })();

  useEffectOnce(() => {
    if (value) {
      localStorage.removeItem(localStorageKey);
    }
  });

  return value;
};
